export const getStatusColor = (slug: string) => {
  switch (slug) {
    case 'new':
      return 'success';
    case 'work':
      return 'primary';
    case 'confirmation':
      return 'warning';
    default:
      return 'default';
  }
};
